let $cvg = null;

if (typeof window !== undefined) {
   $cvg = require('canvg');
}

import Canvg from 'canvg';

interface IOptions {
   height: number;
   width: number;
}

export default function renderSVGToCanvas(input: SVGElement, options: IOptions, isHighchart: boolean, callback) {
   let svgAsXML = new XMLSerializer().serializeToString(input);
   const height = options.height;
   const originalHeight = document.getElementById('HCDIV').getElementsByTagName('svg')[0].getAttribute('height');
   const originalWidth = document.getElementById('HCDIV').getElementsByTagName('svg')[0].getAttribute('width');
   const width = options.width;
   const scaleHeight = height * 2;
   const scaleWidth = width * 2;
   const canvas = document.createElement('canvas');
   canvas.style.display = 'none';
   document.body.appendChild(canvas);
   const ctx = canvas.getContext('2d');
   canvas.width = scaleWidth + 10;
   canvas.height = scaleHeight + 10;
   ctx.fillStyle = '#FFFFFF';
   ctx.fillRect(0, 0, canvas.width, canvas.height);
   if (svgAsXML === null) {
      return new HTMLCanvasElement();
   }
   // manipulate raw svg string for proper scaling...
   // remove unwanted text...
   // and get that xlink namespace in there.
   svgAsXML = svgAsXML
      .replace('width="' + originalWidth + '"', 'width="' + scaleWidth + '"')
      .replace('height="' + originalHeight + '"', 'height="' + scaleHeight + '"')
      .replace('<svg', '<svg xmlns:xlink="http://www.w3.org/1999/xlink"')
      .replace(/NS\d+:href/g, 'xlink:href') // safarifix
      .replace(' (see below for notes and methodologies).', '');
   if (isHighchart) {
      const v = Canvg.fromString(ctx, svgAsXML, {
         scaleWidth,
         scaleHeight
      });

      v.render().then(() => {
         callback(canvas, 'data:image/svg+xml; charset=utf8, ' + encodeURIComponent(svgAsXML));
      });
   } else {
      const v = Canvg.fromString(ctx, svgAsXML, {
         scaleWidth: scaleWidth * 2,
         scaleHeight: scaleHeight * 2
      });

      v.render().then(() => {
         callback(canvas, 'data:image/svg+xml; charset=utf8, ' + encodeURIComponent(svgAsXML));
      });
   }
   return canvas;
}

export function RenderImageToCanvas(url: string, options: IOptions, isHighchart: boolean, callback) {
   const canvas = document.createElement('canvas') as HTMLCanvasElement;
   const ctx = canvas.getContext('2d');
   document.body.appendChild(canvas);
   canvas.width = (options.width + 10) * 2;
   canvas.height = (options.height + 10) * 2;
   ctx.fillStyle = 'white';
   ctx.fillRect(0, 0, canvas.width, canvas.height);
   const img = new Image();
   img.onload = () => {
      canvas.getContext('2d').drawImage(img, 10, 10, canvas.width - 20, canvas.height - 20);
      callback(canvas);
      document.body.removeChild(canvas);
   };
   img.src = url;
   return canvas;
}
